import React, { useState, useEffect, useRef } from "react";
import { CFormInput, CButton, CFormSelect, CTable, CToast, CToastBody, CToaster } from '@coreui/react';
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useParams, useNavigate } from 'react-router-dom';
import { CSSProperties } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import { FaRegCopy, FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import CICDIntegrations from './cicdIntegrations';
import IDEIntegrations from './ideIntegrations';
import TicketingIntegrations from './ticketingIntegrations';

import DockerIntegration from './dockerIntegration';
import ResultAPIsIntegration from './resultAPIs';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import AccessTokens from "./accessTokens";

import jwt_decode from 'jwt-decode';

const Integrations = () => {
  const navigate = useNavigate();
  const [organization, setOrganization] = useState({});
  const [onLoading, setOnLoading] = useState(false);

  const [clientId, setClientId] = useState('');
  const [clientIdCopied, setClientIdCopied] = useState(false);

  const [clientSecret, setClientSecret] = useState('');
  const [isClientSecretVisible, setIsClientSecretVisible] = useState(false);

  const [userRole, setUserRole] = useState(null);

  const toaster = useRef();

  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };

  useEffect(() => {
    // loadOrganizationDetails();

    // const user =  JSON.parse(sessionStorage.getItem('ASIUser'));

   const roleToken = sessionStorage.getItem('accessLevel');
   const decodedToken = jwt_decode(roleToken);
   const userRole = decodedToken.role;
  //  console.log("usssRole",userRole)
    setUserRole(userRole);
    window.scrollTo(0, 0);
    fetchOrganizationDetails()
  }, []);

  const fetchOrganizationDetails = async () => {

    setOnLoading(true)

    const token = sessionStorage.getItem('ASIToken');

    try {
      const response = await axios.get('api/v1/integrations/getAccessTokenOne', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

     
      // setTokens(response.data.data)
      setOnLoading(false)

      // setOrganization(response.data.organization);
      setClientId(response.data.data.clientId);
      setClientSecret(response.data.data.secretId);
      
    } catch (error) {
      setOnLoading(false)
      console.error('Error fetching organization details:', error);
    }
  };

  const loadOrganizationDetails = async () => {
    try {
      setOnLoading(true);

      const token = sessionStorage.getItem('ASIToken');
      console.log('Token:', token);  // Log token for debugging

      if (!token) {
        throw new Error('No token found in sessionStorage');
      }

      const response = await axios.get('/api/v1/organizations/organization-details', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('Organization Details:', response.data);

      setOrganization(response.data.organization);
      setClientId(response.data.organization.clientId);
      setClientSecret(response.data.organization.clientSecret);

    } catch (error) {
      setOnLoading(false);

      if (error.response && error.response.status === 401) {
        toast.error('Unauthorized access. Please log in again.' + error.response.data.message);
        // Optionally redirect to login:
        // sessionStorage.removeItem('ASIToken');
        // sessionStorage.removeItem('ASIUser');
        // navigate('/');
      } else {
        toast.error('Failed to load organization details.');
      }
    } finally {
      setOnLoading(false);
    }
  };

  const notifyClientIdCopied = async () => {
    toast('Client ID copied to the clipboard', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const notifyClientSecretCopied = async () => {
    toast('Client secret copied to clipboard', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const toggleClientSecretVisibility = () => {
    setIsClientSecretVisible(!isClientSecretVisible);
  };

  return (
    <div style={{ overflow: "scroll", position: 'relative', overflowY: 'hidden', overflowX: 'hidden', }}>
      <div style={{ width: '100%' }}>

        <div>
          <div style={{ marginBottom: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

            <h4 style={{ color: '#fff', fontWeight: 'bold' }}>Integrations</h4>
            <hr />

            {/* Loading Placeholder or Data */}

            {/* {onLoading ? (
              <ShimmerTable row={0} col={2} />
            ) : (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ width: '60%' }}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span style={{ fontWeight: 'bold' }}>Client ID :</span> 
                    <span style={{ marginLeft: 10 }}>{clientId}</span>
                    <CopyToClipboard text={clientId} onCopy={() => notifyClientIdCopied()}>
                      <FaRegCopy color="#fff" style={{ cursor: 'pointer', marginLeft: 20 }} />
                    </CopyToClipboard>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <span style={{ fontWeight: 'bold' }}>Client Secret:</span>
                    <span style={{ marginLeft: 10 }}>
                      {isClientSecretVisible ? clientSecret : '•'.repeat(clientSecret.length)}
                    </span>
                    <span
                      onClick={toggleClientSecretVisibility}
                      style={{ cursor: 'pointer', marginLeft: 10 }}
                    >
                      {isClientSecretVisible ? (
                        <FaEyeSlash color="#fff" />
                      ) : (
                        <FaEye color="#fff" />
                      )}
                    </span>
                    {isClientSecretVisible && (
                      <CopyToClipboard text={clientSecret} onCopy={() => notifyClientSecretCopied()}>
                        <FaRegCopy color="#fff" style={{ cursor: 'pointer', marginLeft: 20 }} />
                      </CopyToClipboard>
                    )}
                  </div>
                </div>
              </div>
            )} */}

          </div>
        </div>

        <Tabs className="addAgentPage">
          <TabList style={{ borderWidth: 0, display: 'flex', justifyContent: 'flex-start' }}>
            <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
              <span style={{ color: '#fff' }}>CI/CD Integrations</span>
            </Tab>
            <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
              <span style={{ color: '#fff' }}>IDE Integrations</span>
            </Tab>
            <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
              <span style={{ color: '#fff' }}>Ticketing Integrations</span>
            </Tab>
            <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
              <span style={{ color: '#fff' }}>Docker Integration</span>
            </Tab>
            <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
              <span style={{ color: '#fff' }}>Scan Result JSON API</span>
            </Tab>

            {
               ["Administrator"].includes(userRole) ? 
              <Tab style={{ width: 200, borderWidth: 0, textAlign: 'center' }}>
                <span style={{ color: '#fff' }}>Access Tokens</span>
              </Tab>
              :
              ""
            }
           
          </TabList>

          {/* CI/CD Integrations  */}
          <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
            <CICDIntegrations />
          </TabPanel>

          {/* IDE Integrations  */}
          <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
            <IDEIntegrations />
          </TabPanel>

          {/* Ticketing Integrations  */}
          <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
            <TicketingIntegrations />
          </TabPanel>

          {/* Docker Integration */}
          <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
            <DockerIntegration />
          </TabPanel>

          {/* Scan Result JSON API */}
          <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
            <ResultAPIsIntegration />
          </TabPanel>

          {/* Access Tokens */}

          {

             ["Administrator"].includes(userRole) ? 
            
              <TabPanel style={{ padding: 30, backgroundColor: 'white', borderRadius: 5 }}>
                <AccessTokens />
              </TabPanel>
          :
          ""
          }
          

        </Tabs>
      </div>
    </div>
  );
};

export default Integrations;
